var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4258 41.0938H0.765625V27.7461C0.765625 22.3451 1.23047 18.0951 2.16016 14.9961C3.13411 11.8529 4.90495 9.04167 7.47266 6.5625C10.0404 4.08333 13.3164 2.13542 17.3008 0.71875L20.9531 8.42188C17.2344 9.66146 14.556 11.388 12.918 13.6016C11.3242 15.8151 10.4831 18.7591 10.3945 22.4336H19.4258V41.0938ZM50.5703 41.0938H31.9102V27.7461C31.9102 22.3008 32.375 18.0286 33.3047 14.9297C34.2786 11.8307 36.0495 9.04167 38.6172 6.5625C41.2292 4.08333 44.5052 2.13542 48.4453 0.71875L52.0977 8.42188C48.3789 9.66146 45.7005 11.388 44.0625 13.6016C42.4688 15.8151 41.6276 18.7591 41.5391 22.4336H50.5703V41.0938Z",
    fill: "#58585D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockQuote);
export default __webpack_public_path__ + "static/media/BlockQuote.1319f617.svg";
export { ForwardRef as ReactComponent };